import useFormStatus from "@/context/form";
import { useEffect } from "react";

const useFormListeners = (id: string, isDirty: boolean, isSubmitting: boolean) => {
    const { setId, reset, setState } = useFormStatus();

    useEffect(() => {
        setState({ isDirty, isSubmitting });
    }, [isDirty, isSubmitting]);

    useEffect(() => {
        setId(id);

        return reset;
    }, []);
};

export default useFormListeners;
